import React from 'react';
import View from 'styleguide/View/View';
import style from '../Tabs.module.scss';

export default function TabsList(props: any) {
  return <View className={style.Tabs}>{props.children}</View>;
}
